"use client"

import { Mail, Phone } from "lucide-react"

export function ContactSection() {
  return (
    <section
      id="contact"
      className="py-16 lg:py-20 bg-gradient-to-br from-white via-[#f3edff] to-white overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-6">
        {/* Header centered */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-black tracking-tight">
            Contact
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Vous avez des questions ou souhaitez rejoindre PolyMeet ? Contactez-nous directement !
          </p>
        </div>

        {/* Contact Cards */}
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Email */}
          <a
            href="mailto:polymeet@example.com"
            className="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-[#e5ddff]
              transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl"
          >
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#5e17eb] to-[#7c3aed] rounded-2xl flex items-center justify-center icon-float text-white group-hover:scale-110 transition-transform duration-300">
                <Mail className="w-8 h-8" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-[#5e17eb] transition-colors">
                  Envoyez-nous un email
                </h3>
                <p className="text-gray-600 mb-4">
                  Cliquez ici pour envoyer un message directement depuis votre application email.
                </p>
                <div className="text-[#5e17eb] font-semibold text-lg">
                  polymeet@example.com
                </div>
                <div className="mt-3 text-sm text-gray-500">📧 Ouvre votre application email</div>
              </div>
            </div>
          </a>

          {/* Phone */}
          <a
            href="tel:+213665337925"
            className="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-[#e5ddff]
              transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl"
          >
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 bg-gradient-to-br from-[#7c3aed] to-[#5e17eb] rounded-2xl flex items-center justify-center icon-float text-white group-hover:scale-110 transition-transform duration-300">
                <Phone className="w-8 h-8" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-[#5e17eb] transition-colors">
                  Appelez-nous
                </h3>
                <p className="text-gray-600 mb-4">
                  Contactez-nous directement par téléphone pour une réponse immédiate.
                </p>
                <div className="text-[#5e17eb] font-semibold text-lg">
                  +213 665 337 925
                </div>
                <div className="mt-3 text-sm text-gray-500">📞 Appel direct</div>
              </div>
            </div>
          </a>
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-[#e5ddff]">
            <h4 className="text-xl font-bold text-gray-900 mb-3">Nous sommes là pour vous aider</h4>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Que vous souhaitiez participer à nos événements, proposer une collaboration, ou simplement en savoir
              plus sur PolyMeet, n'hésitez pas à nous contacter !
            </p>

            {/* Social Media */}
            <div className="mt-6 flex justify-center gap-4">
              <button className="w-12 h-12 bg-gradient-to-br from-[#5e17eb] to-[#7c3aed] hover:from-[#7c3aed] hover:to-[#5e17eb] rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg">
                <span className="text-white font-bold text-base">f</span>
              </button>
              <button className="w-12 h-12 bg-gradient-to-br from-[#5e17eb] to-[#7c3aed] hover:from-[#7c3aed] hover:to-[#5e17eb] rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg">
                <span className="text-white font-bold text-base">@</span>
              </button>
              <button className="w-12 h-12 bg-gradient-to-br from-[#5e17eb] to-[#7c3aed] hover:from-[#7c3aed] hover:to-[#5e17eb] rounded-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg">
                <span className="text-white font-bold text-base">📷</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
